import React, { memo, PropsWithChildren } from 'react';

export type AccessibleModalProps = PropsWithChildren<any>;

const AccessibleModal = ({ children, ...rest }: AccessibleModalProps) => (
  <div role='alertdialog' aria-modal='true' {...rest}>
    {children}
  </div>
);

export default memo(AccessibleModal);
